/**
 * Fuseaux proposés à une entreprise (Mon entreprise > Identité). Ils couvrent la
 * France métropolitaine et l'outre-mer ; le fuseau décide des heures écrites dans
 * les avis, des jours de rappel et de la fin de journée des relevés. Europe/Paris
 * est le défaut.
 */
export const COMPANY_TIMEZONES = [
  { value: 'Europe/Paris', label: 'Métropole (Paris)' },
  { value: 'America/Martinique', label: 'Martinique' },
  { value: 'America/Guadeloupe', label: 'Guadeloupe, Saint-Martin, Saint-Barthélemy' },
  { value: 'America/Cayenne', label: 'Guyane' },
  { value: 'Indian/Reunion', label: 'La Réunion' },
  { value: 'Indian/Mayotte', label: 'Mayotte' },
  { value: 'America/Miquelon', label: 'Saint-Pierre-et-Miquelon' },
  { value: 'Pacific/Noumea', label: 'Nouvelle-Calédonie' },
  { value: 'Pacific/Tahiti', label: 'Polynésie française' },
  { value: 'Pacific/Wallis', label: 'Wallis-et-Futuna' },
] as const;

export type CompanyTimezone = (typeof COMPANY_TIMEZONES)[number]['value'];

export const COMPANY_TIMEZONE_VALUES = COMPANY_TIMEZONES.map((zone) => zone.value) as [CompanyTimezone, ...CompanyTimezone[]];
